import ISvgProps from '../../../SvgLoader/ISvgProps';

function SvgCalendarMid(props: ISvgProps) {
	return (
		<svg width={61} height={60} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<g clipPath="url(#CalendarMid_svg__a)">
				<g clipPath="url(#CalendarMid_svg__b)">
					<path
						d="M7.55 59.647h44.096c3.49 0 6.385-2.861 6.385-6.372V11.25c0-3.51-2.895-6.345-6.385-6.345h-6.28v-3.38c0-.65-.517-1.17-1.164-1.17-.646 0-1.163.52-1.163 1.17v3.38H16.158v-3.38c0-.65-.517-1.17-1.163-1.17s-1.163.52-1.163 1.17v3.38H7.55c-3.49 0-6.384 2.835-6.384 6.345v42.026c0 3.511 2.895 6.372 6.384 6.372Zm44.096-2.34H7.551c-2.21 0-4.058-1.808-4.058-4.032V20.768h52.21v32.507c0 2.224-1.847 4.031-4.057 4.031ZM7.551 7.244h6.28v3.329c0 .65.518 1.17 1.164 1.17.646 0 1.163-.52 1.163-1.17v-3.33h26.88v3.33c0 .65.518 1.17 1.164 1.17.646 0 1.163-.52 1.163-1.17v-3.33h6.281c2.21 0 4.058 1.782 4.058 4.006v7.177H3.493V11.25c0-2.224 1.848-4.005 4.058-4.005Z"
						fill={props.primaryColor}
					/>
					<rect x={7.762} y={24.674} width={43.672} height={5.992} rx={2.996} fill={props.secondaryColor} />
				</g>
			</g>
			<defs>
				<clipPath id="CalendarMid_svg__a">
					<path fill="#fff" transform="translate(.598)" d="M0 0h60v60H0z" />
				</clipPath>
				<clipPath id="CalendarMid_svg__b">
					<path fill="#fff" transform="translate(.598)" d="M0 0h58v60H0z" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default SvgCalendarMid;
